import React from 'react'

const styles = {
    h2Tag: 'text-2xl sm:text-3xl font-semibold text-lyellow',
    spanTag: 'text-lyellow font-semibold',
}

const Rules = () => {
  return (
    <>
        <div className='mt-5'>
            <h2 className={styles.h2Tag}>Grab A Bag<span className='text-white'>&nbsp;Marketing Giveaway</span></h2>
            <div className='mt-3 gap-y-2 text-lg text-white flex flex-col'>
                <p><span className={styles.spanTag}>1.</span>&nbsp;The Giveaway is open to all users of the platform.</p>
                <p><span className={styles.spanTag}>2.</span>&nbsp;No Purchase is necessary</p>
                <p><span className={styles.spanTag}>3.</span>&nbsp;Void where prohibited.</p>
                <p><span className={styles.spanTag}>2.</span>&nbsp;Share on twitter and get a chance to win USDT.</p>
                <p><span className={styles.spanTag}>3.</span>&nbsp;The more you share the higher your chances get.</p>
            </div>
            <div className='text-xs text-lyellow mt-4'>
                <p className='leading-6'>All rules are final. Grab A Bag reserves the right to modify these rules as needed. This includes times, dates, prize amounts, token price payouts, and all other terms and conditions associated with this contest whether the condition is/is not outlined in the official rules. Grab A Bag reserves the right to postpone, modify, or cancel this contest as needed.</p>
            </div>
        </div>
    </>
  )
}

export default Rules